export default {
  planningMapView: {
    baseMap: "Bản đồ nền",
    toolsMap: "Công cụ bản đồ",
    googleMap: "Bản đồ Google",
    satelliteMap: "Bản đồ vệ tinh",
    notUseBaseMap: "Không dùng bản đồ nền",
    mapToolsPanel: {
      viewObjectInfomation: "Xem thông tin đối tượng",
      toggleFullScreen: "Mở rộng/Thu nhỏ",
      zoomIn: "Phóng to bản đồ",
      zoomOut: "Thu nhỏ bản đồ",
      filterInfomation: "Lọc thông tin",
      mapLegend: "Chú giải bản đồ",
      selectAnObject: "Chọn một đối tượng",
      selectMultiObject: "Chọn nhiều đối tượng",
      measuareArea: "Đo diện tích",
      measuareDistance: "Đo khoảng cách",
      moveViewport: "Di chuyển khung nhìn",
      printTheMap: "In bản đồ",
      myPosition: "Xác định vị trí của bạn",
      exportMap: "Xuất bản đồ",
      compare: "So sánh",
      locationMarker: "Đánh dấu vị trí",
    },
    filterInfomationPopup: {
      headTitle: "Tìm kiếm đối tượng",
      labelSelectSearch: "Chọn đối tượng tìm kiếm",
      searchInLine: "Tìm kiếm trên đường",
      searchInArea: "Tìm kiếm trong vùng",
      searchInCircle: "TÌm kiếm trong đường tròn",
      searchInSquare: "Tìm kiếm trong hình chữ nhật",
      searchWithAttribute: "Theo thuộc tính",
      search: "Tìm kiếm",
      delete: "Xóa",
      close: "Đóng",
    },
  },
    planningMapView_guideToUse: "Giới thiệu khu công nghiệp",
  planningMapView_guideToUse_category: "Danh mục hướng dẫn",
  planningMapView_map: "Bản đồ",
  planningMapView_infomation: "Thông tin",
  planningMapView_relatedPlanning: "Quy hoạch liên quan",
  planningMapView_result: "Kết quả",
  header_homePage: "Trang chủ",
  header_pleaseConsultTheCommunity: "Xin ý kiến cộng đồng",
  header_lookUpPlanning: "Tra cứu quy hoạch",
  header_news: "Tin tức",
  header_planningAnnouncement: "Công bố quy hoạch",
  header_recordsManager: "Quản lý hồ sơ",
  header_Contact: "Liên hệ",
  header_generalPlanning: "Quy hoạch chung",
  header_syntheticPlanning: "Tổng hợp khu công nghiệp",
  header_subdivisionPlanning: "Quy hoạch phân khu",
  header_detailedPlanning: "Quy hoạch chi tiết",
  header_specializedPlanning: "Quy hoạch chuyên ngành",
  header_administration: "Quản trị",
  header_logout: "Đăng xuất",
  header_logIn: "Đăng Nhập",
  header_account: "Tài khoản",
  header_title: "GIS Tiên Yên",
  footer_titleName: "BAN QUẢN LÝ CÁC KHU CÔNG NGHIỆP, KHU KINH TẾ ĐỒNG NAI",
  footer_email: "bqlkcn@dongnai.gov.vn",
  footer_email_to: "bqlkcn@dongnai.gov.vn",
  footer_address: "Số 26, đường 2A, KCN Biên Hòa II, phường Trấn Biên, tỉnh Đồng Nai.",
  footer_hotline: "(0251) 3892378",
  footer_hotline_tel: "(0251) 3892378",
  footer_fax: "(0251) 3892379",
  footer_website: "https://dnieza.dongnai.gov.vn/",
  footer_website_to: "https://dnieza.dongnai.gov.vn/", 
  contact_map_center_lat: 21.312379,
  contact_map_center_lng: 105.603325,
  contact_map_marker_lat: 21.312379,
  contact_map_marker_lng: 105.603325,
  contact_map_url: 'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15669.427483006635!2d106.869881!3d10.936392!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3174d986328f2a4b%3A0x5bb82bf232dde594!2sDong%20Nai%20Industrial%20Parks%20Management%20Board!5e0!3m2!1sen!2sus!4v1770867651628!5m2!1sen!2sus',
};
